import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import { Checkbox, CircularProgress, ListItemText, MenuItem, Select } from "@mui/material";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import traderService from "../../../components/Services/trader.service";
import companyAdminService from "../../../components/Services/companyAdmin.service";
import { useDispatch, useSelector } from "react-redux";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";

const SelectTraderModal = ({ isOpen, handleTraderSelectPopup,getAllCompanyAdminUsers }) => {
 const [tradersList, setTradersList] = useState([]);
 const isButtonEnabled = useSelector(
  (state) => state?.buttonReducer?.isButtonEnabled
 );
 const dispatch = useDispatch();
 const initialValues = {
  selectTrader: tradersList
   ?.filter((item) => item.selectedTrader)
   .map((item) => item.id),
 };

 const getAllTradersList = () => {
  traderService
   .getAllTradersList()
   .then((res) => {
    if (res?.data?.code === 200) {
     setTradersList(res?.data?.data);
    }
   })
   .catch((err) => console.log(err));
 };
 useEffect(() => {
  getAllTradersList();
 }, []);
 const ITEM_HEIGHT = 48;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
  PaperProps: {
   style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 250,
   },
  },
 };
 const modifyTraders = (reqBody) => {
  disableButton()(dispatch);
  companyAdminService
   .modifyTraders(reqBody)
   .then((response) => {
    if (response?.data?.code === 200) {
     toast.success(response?.data?.message, toastProperties);
     handleTraderSelectPopup();
     enableButton()(dispatch);
     getAllCompanyAdminUsers();
    }else if(response?.data.code !== 200){
      enableButton()(dispatch)
    }
   })
   .catch((err) => console.log(err));
 };
 return (
  <>
   <Modal show={isOpen} onHide={handleTraderSelectPopup} centered size="lg">
    <Modal.Header closeButton>
     <Modal.Title>Select Traders For My Company</Modal.Title>
    </Modal.Header>
    <Modal.Body className="m-3" style={{ minHeight: "200px" }}>
     {tradersList?.length > 0 ? (
      <Formik
       initialValues={initialValues}
       onSubmit={(values) => {
        let reqBody = (values?.selectTrader).map((id) => ({
         id,
         selectedTrader: true,
        }));
        modifyTraders(reqBody);
       }}
      >
       {({ values,errors, setFieldValue }) => {
        console.log("Form_values_selectTrader==>",{values,errors})
        return (
         <Form>
          <Row>
           <Col md={6}>
            <div>
             <label>
              Select Trader &nbsp;
              <OverlayTrigger
               placement="right"
               overlay={<Tooltip>You can Select Multiple Traders.</Tooltip>}
              >
               <InfoOutlinedIcon fontSize="small" />
              </OverlayTrigger>
             </label>
             <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple
              name="selectTrader"
              value={values?.selectTrader}
              onChange={(e) => setFieldValue("selectTrader", e.target.value)}
              renderValue={(selected) => {
                // Get the userNames of the selected items
                const selectedUserNames = tradersList
                  .filter((item) => selected.includes(item.id))
                  .map((item) => item.userName);
                // Join the userNames with a comma separator
                return selectedUserNames.join(', ');
              }}
              style={{ width: "100%" }}
              MenuProps={MenuProps}
             >
              {tradersList?.map((item, i) => (
               <MenuItem key={i} value={item?.id}>
                <Checkbox checked={values?.selectTrader.indexOf(item?.id) > -1} />
                <ListItemText primary={item?.userName} />
               </MenuItem>
              ))}
             </Select>
            </div>
           </Col>
           <Col md={6}>
            <div className="text-center mt-4 fw-bold">
             <Button className="btn btn-lg btn-signup" type="submit" disabled={isButtonEnabled} >
              Submit
             </Button>
            </div>
           </Col>
          </Row>
         </Form>
        );
       }}
      </Formik>
     ) : (
      <div className="text-center">
       <CircularProgress />
      </div>
     )}
    </Modal.Body>
   </Modal>
  </>
 );
};

export default SelectTraderModal;
